import React from 'react';
import CouponsPromoFop from 'apps/coupons/components/CouponsPromoFop';

function addCouponsPromoFopToSection(section, couponsSummary = {}) {
  return {
    ...section,
    contentBeforeFops: [
      <CouponsPromoFop key="coupons-promo-fop" {...couponsSummary} />,
      ...(section.contentBeforeFops || []),
    ],
  };
}

export default function generateFopCollectionWithCouponsPromoFop(fopCollection, couponsSummary) {
  const { sections } = fopCollection;
  if (!sections || !sections[0]) {
    return fopCollection;
  }

  return {
    ...fopCollection,
    sections: [
      addCouponsPromoFopToSection(sections[0], couponsSummary),
      ...sections.slice(1),
    ],
  };
}
